import styled from '@emotion/styled';
import { css_gap, css_medium_up, css_text } from '~/emotion/theme';

export interface WysiwygBlockVariant {
	id: string;
	title?: string;
	children: React.ReactNode;
}

export const BLOCK_WYSIWYG_STYLE = styled.div`
	color: ${css_text()};
	font-size: 1rem;
	line-height: 1.5rem;

	p {
		margin: 0;
	}

	p + p {
		margin-top: ${css_gap('content')};
	}

	@media (${css_medium_up}) {
		font-size: 1.2rem;
		line-height: 2rem;
	}
`;
